import Vue from 'vue';

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => Vue.$http.get('/marketplace/partners')
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        failed(error, reject);
      }))
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceCustomer/partners.js